export class AgentStreamProtocolError extends Error {
  constructor(message = "The agent stream returned an invalid response.") {
    super(message);
    this.name = "AgentStreamProtocolError";
  }
}

export class AgentStreamConnectionError extends Error {
  constructor() {
    super("The connection to the agent stream was interrupted.");
    this.name = "AgentStreamConnectionError";
  }
}

export class AgentStreamTerminalError extends Error {
  readonly code: string;
  readonly correlationId: string;

  constructor(code: string, message: string, correlationId: string) {
    super(message);
    this.name = "AgentStreamTerminalError";
    this.code = code;
    this.correlationId = correlationId;
  }
}
